import React, { useState, useCallback } from 'react'
import PopoverConfirm from '@/components/popover-confirm/popover-confirm'
import { Column, Row } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'

import './edit-purchase.scss'
import { ColumnsType } from 'antd/es/table'
import Iconfont from '@/components/iconfont/iconfont'
import { Table } from 'antd'
import { showLayer } from '@/utils/layer'
import ChooseGoodsUnitDialog from '../../../../goods-storage/goods-library/modules/edit-goods/modules/goods-unit/goods-unit'
import { goodsModel } from '../../../../goods-storage/goods-library/modules/edit-goods/modules/model'
import { Unit } from '@/model/types/goods'
import { useUpdateEffect } from 'ahooks'
import Big from 'big.js'

interface PurchaseUnitPopoverProps {
    unit: Unit
    stockUnit: Unit
    positive: boolean
    unitRatio: number
    onChange: (val: { unit: Unit; unitRatio: number; positive: boolean }) => void
}

interface Idata {
    unit: string
    ratio: number
    id: number
}

const PurchaseUnitPopover: React.FC<PurchaseUnitPopoverProps> = props => {
    const cls = (...arg: string[]) => getBEMCls('edit-purchase', ...arg)
    const [val, setVal] = useState<string | number>(props.unitRatio)
    const [chooseUnit, setChooseUnit] = useState<Unit | null>(null)
    const [visable, setVisable] = useState<boolean>(false)
    const [isPostitive, setIsPositive] = useState<boolean>(props.positive)

    const hidden = useCallback(() => {
        setVisable(false)
    }, [])

    useUpdateEffect(() => {
        props.onChange({
            unit: chooseUnit as Unit,
            unitRatio: +val,
            positive: isPostitive,
        })
    }, [chooseUnit])

    const columns: ColumnsType<Idata> = [
        {
            title: '采购单位',
            dataIndex: 'unit',
            key: 'unit',
            render: () => (
                <Row
                    data-cursor-pointer
                    data-align-items-center
                    onClick={() => {
                        hidden()
                        showLayer(
                            <ChooseGoodsUnitDialog
                                goodsModel={goodsModel}
                                choosedId={props.unit.id}
                                onChange={e => {
                                    setChooseUnit(e as Unit)
                                }}
                            />,
                        )
                    }}
                >
                    {chooseUnit ? chooseUnit.name : props.unit.name}
                    <Iconfont data-margin-left-4 name="icon6youjiantou-20" size={16} />
                </Row>
            ),
        },
        {
            title: '换算规则',
            dataIndex: 'ratio',
            key: 'ratio',
            width: 341,
            render: (s, record) => (
                <Row data-align-items-center>
                    <Row data-align-items-center>
                        {!isPostitive ? props.stockUnit.name : chooseUnit ? chooseUnit.name : props.unit.name}
                        {!isPostitive && (
                            <div data-font-size-12 data-color-999>
                                （库存单位）
                            </div>
                        )}
                    </Row>
                    =
                    <input
                        className={cls('ipt')}
                        value={val || ''}
                        placeholder="请输入"
                        onChange={e => {
                            setVal(e.target.value)
                        }}
                    />
                    <div data-font-size-12 data-color-999 data-margin-right-14>
                        {!isPostitive ? (chooseUnit ? chooseUnit.name : props.unit.name) : props.stockUnit.name}
                        {isPostitive && '（库存单位）'}
                    </div>
                    <Row
                        data-cursor-pointer
                        data-algin-items-center
                        onClick={() => {
                            setIsPositive(val => !val)
                            setVal(v => +Big(1).div(v).toFixed(2))
                        }}
                    >
                        <Iconfont name="iconqiehuanhuansuanfangshi" size={20} />
                        <div data-font-size-12 data-margin-left-6 data-color-blue data-font-weight-600>
                            切换换算方式
                        </div>
                    </Row>
                </Row>
            ),
        },
    ]

    return (
        <PopoverConfirm
            visible={visable}
            onVisibleChange={visible => {
                setVisable(visible)
            }}
            disabled={!val}
            onCancel={hidden}
            trigger="click"
            placement="topRight"
            onConfirm={() => {
                hidden()
                if (val === props.unitRatio) return
                props.onChange({
                    unit: !chooseUnit ? props.unit : (chooseUnit as Unit),
                    unitRatio: +val,
                    positive: isPostitive,
                })
            }}
            content={
                <Column>
                    <div data-color-000 data-font-size-14>
                        采购单位
                    </div>
                    <div data-font-size-12 data-color-999 data-margin-v-8>
                        *最多支持2位小数
                    </div>
                    <div className={cls('unit-con')}>
                        <Table
                            rowKey={record => record.id}
                            dataSource={[
                                {
                                    unit: props.unit.name,
                                    ratio: props.unitRatio,
                                    id: 0,
                                },
                            ]}
                            bordered
                            pagination={false}
                            columns={columns}
                        />
                    </div>
                </Column>
            }
        >
            {props.children}
        </PopoverConfirm>
    )
}

export default PurchaseUnitPopover
